import $ from 'jquery';
import { TweenMax, TimelineMax, Power0 } from 'gsap';

function rint(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function Bubble(id, parentElement) {
  this.id = id;
  this.elems = {};
  this.elems.parent = parentElement;
  this.elems.bubble = $('<div class="animated-bubble"></div>');

  this._bubInterval = null;

  let $bubble = this.elems.bubble;

  this.props = {
    size: 100,
    velocity: 3,
    side: 1,
    delay: 0,
    zindex: -1,
  };
  
  this.randomize = () => {
    this.props.size = rint(50, 130);
    this.props.velocity = rint(3, 20);
    this.props.side = rint(0, 1);
    this.props.delay = rint(0, 7000);
    this.props.zindex = rint(0, 1) ? -1 : 5;
  }

  this.animate = () => {
    clearInterval(this._bubInterval);
    TweenMax.killTweensOf($bubble);
    this.randomize();

    let parentPos = this.elems.parent.offset();
    let parentSize = {
      width: this.elems.parent.width(),
      height: this.elems.parent.height(),
    };
    let ptStart = parentPos.left - this.props.size + rint(0, parentSize.width + this.props.size);
    let ptEnd = ptStart >= parentPos.left + (parentSize.width / 2)
                  ? ptStart + rint(0, parentSize.width / 3.5)
                  : ptStart - rint(0, parentSize.width / 3.5);
    
    $bubble.css({
      opacity: 0,
      left: ptStart, // parentPos.left + (parentSize.width / 2) - (this.props.size / 2),
      top: parentPos.top + (parentSize.height) + 10,
      width: this.props.size,
      height: this.props.size,
      zIndex: this.props.zindex,
    });

    $bubble.show();

    TweenMax.to($bubble, 1, {
      opacity: 1,
    });

    TweenMax.to($bubble, .5, {
      opacity: 0,
      delay: this.props.velocity - rint(1.5, 10),
      onComplete: () => this.animate(),
    });

    TweenMax.to($bubble, this.props.velocity, {
      top: parentPos.top - this.props.size / 2,
      left: ptEnd, // parentPos.left + parentSize.width,
    });

    let direction = rint(0,1) ? -1 : 1;
    let dirSpeed = 1000;
    let dirSpace = 10;
    let swipeBubble = () => {
      dirSpace = rint(3, 15);
      TweenMax.to($bubble, dirSpeed / 1000, {
        marginLeft: dirSpace * direction,
        ease: Power0.easeNone
      });
      direction *= -1;
    };
    this._bubInterval = setInterval(swipeBubble, dirSpeed);
    swipeBubble();

    // setTimeout(this.animate, this.props.velocity * 1000 + this.props.delay);
  }

  console.log('bubble created');
  $bubble.appendTo('body');

  setTimeout(this.animate, rint(0, 10000));
}


function AnimatedBubbles(el) {
  this.elems = {};
  this.elems.root = $(el);
  this.bubblesCount = 7;
  this.bubbles = [];

  this.makeBubbles = function makeBubbles() {
    for(let i=0; i<this.bubblesCount; i++) {
      let bubble = new Bubble(i, this.elems.root);
      this.bubbles.push(bubble);
    }
  }

  this.makeBubbles();
}




$(document).ready(function() {
  $('[data-animated-bubbles]').each(function() {
    new AnimatedBubbles(this);
  });
});
